import { Card, Col, CardHeader, Container, Row, Alert } from "reactstrap";
import { H5, H2 } from "../../AbstractElements";
// import {   URL_API } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFourListe from "../Fournisseurs/FourApi";
import GestFacture from "./factures";
import GestRecu from "./recu";

const FactureRecu = () => {

    const [type, setType] = useState('factures')
    const [idFournisseur, setIdFournisseur] = useState<number>()
    const [refresh, setRefresh] = useState(false)
    const fournisseur = useFourListe(refresh)

    const selectType = ({ type }: { type: string }) => {
        setType(type);
    }

    useEffect(() => {

    }, [idFournisseur, selectType])

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Factures & reçus" parent="Caisses" />
            <Container fluid>

                {
                    fournisseur.length > 0 ? (
                        <>
                            <Row>
                                {/* {
                                    fournisseur.map((item, index) => ( */}
                                        <Col sm={6}>
                                            <Card className={`progress-items pb-0 ${type == 'factures' ? 'bg-light-success' : 'bg-light-info'}`} onClick={() => selectType({ type: 'factures' })}>
                                                <CardHeader className={`pb-4 ${type == 'factures' ? 'bg-light-success' : 'bg-light-info'}`}>
                                                    <H5 className="text-center">
                                                        <span className="fw-bold">Factures</span>
                                                    </H5>
                                                </CardHeader>
                                            </Card>
                                        </Col>
                                        <Col sm={6}>
                                            <Card className={`progress-items pb-0 ${type == 'recu' ? 'bg-light-success' : 'bg-light-info'}`} onClick={() => selectType({ type: 'recu' })}>
                                                <CardHeader className={`pb-4 ${type == 'recu' ? 'bg-light-success' : 'bg-light-info'}`}>
                                                    <H5 className="text-center">
                                                        <span className="fw-bold">Reçus</span>
                                                    </H5>
                                                </CardHeader>
                                            </Card>
                                        </Col>
                                    {/* ))
                                } */}
                            </Row>
                            {
                                type == 'factures' ? (

                                    <GestFacture />

                                ) : type == 'recu' ? (

                                    <GestRecu />

                                ) : (

                                    <Alert color="light-dark" className="text-center">
                                        <H2>Veuillez Selectionner Un Element</H2>
                                    </Alert>

                                )
                            }


                        </>

                    ) : (
                        <div className="loading-container">
                            <div className="spinner-container">
                                <div className="spinner"></div>
                                <span className="loading-text">Chargement de la plateforme...</span>
                            </div>
                        </div>
                    )
                }
            </Container>
        </div >
    )
}

export default FactureRecu;